import React, {Component} from 'react';
import {APP_MODE_OUTSOURCING, APP_MODE_PRODUCT_CHANGE, ARTICLE_CONFIGURATOR_LAYOUT_AGENCY, ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE, ARTICLE_CONFIGURATOR_MODE_SHARED, PROJECT_STATE_DEV} from "../../constants/General";
import {isDevProjectInCart} from "../../selectors/Cart";
import {connect} from "react-redux";
import ReactTooltip from "react-tooltip";
import {isMode} from "../../selectors/Mode";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/pro-light-svg-icons/faPlus";

class ArticleConfiguratorCostsDisplay extends Component {

    shouldComponentUpdate(nextProps, nextState) {

        if (nextProps.cartIsSwappingProgress) {
            return false
        }

        return this.props.costs !== nextProps.costs || this.props.mode !== nextProps.mode || this.props.cartIsSwapping !== nextProps.cartIsSwapping
    }

    componentDidMount() {
        ReactTooltip.rebuild()
    }

    render() {

        const props = this.props;

        let ctaLabel = "";
        let ctaHref = "";
        let websiteLabel = "";

        switch (props.mode) {
            case ARTICLE_CONFIGURATOR_MODE_SHARED:
                ctaLabel = "Agentur-Server und erstes Projekt buchen";
                ctaHref = "https://bestellung.mittwald.de/v3/?article=72000&useConfiguration=shared";

                if (props.layout === ARTICLE_CONFIGURATOR_LAYOUT_AGENCY) {
                    websiteLabel = 'Für dein 1. Projekt (' + (props.state === PROJECT_STATE_DEV ? 'DEV-Projekt' : 'LIVE-Projekt') + ')';
                    ctaLabel = (props.state === PROJECT_STATE_DEV ? "Agentur-Server &\u000ADEV\u2011Projekt\u00A0buchen" : "Agentur-Server &\u000ALIVE\u2011Projekt\u00A0buchen");
                } else if (props.layout === ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE) {
                    websiteLabel = <React.Fragment>
                        Dein erstes Projekt<br/>auf dem Agentur-Server
                    </React.Fragment>
                }
                break;

            case "cms":
                ctaLabel = "Jetzt buchen"
                ctaHref = "https://bestellung.mittwald.de/v3/?&useConfiguration=cms"
                websiteLabel = "Dein CMS-Hosting"
                break;

            case "shop":
                ctaLabel = "Jetzt buchen"
                ctaHref = "https://bestellung.mittwald.de/v3/?&useConfiguration=shop"
                websiteLabel = "Dein Shop-Hosting"
                break;

            default:
                ctaLabel = "Jetzt bestellen"
                break;
        }

        let priceDisplay;
        // mode shared also covers outsourcing case
        const showDifference = props.mode === 'shared' || isMode(APP_MODE_PRODUCT_CHANGE) || isMode(APP_MODE_OUTSOURCING);

        if (props.layout === ARTICLE_CONFIGURATOR_LAYOUT_AGENCY) {
            priceDisplay = <React.Fragment>
                <div className="article-configurator__price__main__block">
                    <span>für den Agentur-Server</span>
                    <strong>10.00 €</strong>
                    <span>pro Monat zzgl. USt.*</span>
                </div>
                <FontAwesomeIcon fixedWidth={true}  icon={faPlus} />
                <div className="article-configurator__price__main__block">
                    <span>für dein 1. Projekt ({(props.state === PROJECT_STATE_DEV ? 'DEV-Projekt' : 'LIVE-Projekt')})</span>
                    <strong>{Number(props.costs).toFixed(props.costs > 0 ? 2 : 0)} €</strong>
                    <span>pro Monat zzgl. USt.*</span>
                </div>
                <FontAwesomeIcon fixedWidth={true} icon={faPlus} />
                <div className="article-configurator__price__main__info">
                    <span>
                        <strong>Weitere Projekte</strong> lassen sich jederzeit Im Kundencenter hinzubuchen und konfigurieren.
                    </span>
                </div>
            </React.Fragment>
        } else if (props.costs > 0 ) {
            priceDisplay = <React.Fragment>
                <strong>{showDifference ? '+ ' : ''}{Number(props.costs).toFixed(props.costs > 0 ? 2 : 0)} €</strong>
                <span>pro Monat, zzgl. USt.*</span>
            </React.Fragment>
        } else if (props.costs < 0) {
            priceDisplay = <React.Fragment>
                <strong>- {Number(Math.abs(props.costs)).toFixed(2)} €</strong>
                <span>pro Monat, zzgl. USt.*</span>
            </React.Fragment>
        } else if (props.isDevProjectInCart) {
            priceDisplay = <React.Fragment>
                <strong>kostenlos</strong>
                <span>während deiner Projektentwicklung</span>
            </React.Fragment>
        } else {
            priceDisplay = <React.Fragment>
                <strong>+ 0 €</strong>
                <span>pro Monat, zzgl. USt.*</span>
            </React.Fragment>
        }

        return (
            <div
                data-tip={(isMode(APP_MODE_PRODUCT_CHANGE) || isMode(APP_MODE_OUTSOURCING)) && showDifference ? 'Dies ist der Differenzbetrag zu deinem aktuell gebuchten Tarif.' : null}
                data-for={"global"}
                data-place="right"
                data-effect="solid"
                data-delay-show="500"
                className={"article-configurator__price" + (props.layout ? " article-configurator__price--layout-" + props.layout : '')}
            >
                {props.layout === ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE ? <div className={"article-configurator__price__label"}>{websiteLabel}</div> : null}
                <div className={"article-configurator__price__main"}>
                    {priceDisplay}
                </div>
                {props.layout === ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE ? <a
                    target="_top"
                    href={ctaHref}
                    className={"article-configurator__price__order"}
                >{ctaLabel}</a> : null}
                {props.layout === ARTICLE_CONFIGURATOR_LAYOUT_AGENCY ? <a
                    target="_top"
                    href={ctaHref}
                    className={"article-configurator__price__order"}
                >{ctaLabel}</a> : null}
            </div>
        );
    }

}


const mapStateToProps = (state) => {
    return {
        isFetching: state.cart && state.cart.isFetching,
        cartIsSwapping: state.cart && state.cart.isSwapping,
        cartIsSwappingProgress: state.cart && state.cart.isSwappingProgress,
        isDevProjectInCart: isDevProjectInCart(state)
    }
}


const mapDispatchToProps = (dispatch, getState) => {

    return {}

}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleConfiguratorCostsDisplay)



/** WEBPACK FOOTER **
 ** ./src/components/configurator/ArticleConfiguratorCostsDisplay.js
 **/